module.exports = __webpack_public_path__ + "static/civicandtech-dc77e8022934c2cbb00fde0d71540056.png";